/*
 The history statement configures the router to use the HTML5 history mode for navigation
 The history mode uses the browser's History API (specifically pushState and replaceState)
 to manipulate the URL without reloading the page.
 This allows for clean, "normal" URLs, like http://example.com/home instead of http://example.com/#/home.
 For this to work, the server has to be set up so all routes should point to your index.html file,
 so Vue Router can handle the routing client-side. This is how we set up in Vue CLI projects.

 In a typical setup, Vue Router's createWebHistory() will use the root of your domain as the base URL.
 However, if your app is deployed to a subdirectory (e.g., http://example.com/myapp/), you need to tell Vue Router
 to expect routes to be prefixed with that subdirectory.
 Again, this is not how this prois set up, so we don't need to provide a parameter to the createWebHistory() function.
 */
import {createRouter, createWebHistory} from "vue-router";
import WessexHome from "../views/WessexHome.vue";


const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: "/",
      name: "WessexHome",
      component: WessexHome
    },
    {
      path: "/features",
      name: "WessexFeatures",
      // route level code-splitting
      // this generates a separate chunk (About.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import("../views/WessexFeatures.vue")
    },
    {
      path: "/podcasts",
      name: "WessexPodcasts",
      component: () => import("../views/WessexPodcasts.vue")
    },
    {
      path: "/about",
      name: "WessexAbout.vue",
      component: () => import("../views/WessexAbout.vue")
    },
    {
      path: "/policies",
      name: "WessexPolicies",
      component: () => import("../views/WessexPolicies.vue")
    },
    {
      path: "/contact",
      name: "WessexContact",
      component: () => import("../views/WessexContact.vue"),
    }
  ]
});

export default router;
